// Copyright 1999-2026. WebPros International GmbH. All rights reserved.

import { ElementType, Fragment } from 'react';
import { Translate as BaseTranslate, TranslateProps as BaseTranslateProps } from '@plesk/ui-library';


export type TranslateProps = Omit<BaseTranslateProps, 'component'> & {
    component?: ElementType;
}

const Translate = ({ component = Fragment, ...props }: TranslateProps) => (
    <BaseTranslate component={component} {...props} />
);

export default Translate;
